module.exports = __webpack_public_path__ + "static/media/ad-shop.f43554eb.png";